import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import imgJen from '../../img/team/jen.jpg';

class LibraryAside extends Component {
  render () {
    return (
      <aside className='ask-an-expert'>
        <img src={imgJen} alt='Jen McTaggart' />
        <div className='ask-an-expert__content'>
          <p>Not sure which course is right for you? Let our experts help.</p>
          <Link to='/contact' className='button button--s button--neutral'>Ask an expert</Link>
        </div>
      </aside>
    );
  }
}

export default LibraryAside;



// WEBPACK FOOTER //
// ./src/components/LibraryAside/index.js